<template>
    <section class="new-cadence-introduction">
        <section class="new-cadence-introduction__title">
            <h1>Kreator Nowej Kadencji</h1>
        </section>
        <section class="new-cadence-introduction__description">
            <p>Witaj w interaktywnym asystencie do automatyzacji procesu przygotowania systemu eSesja dla nowej kadencji organów samorządu terytorialnego. Ten asystent został stworzony, aby ułatwić Ci przenoszenie wszystkich niezbędnych ustawień i danych z poprzedniej kadencji do nowej, eliminując potrzebę ręcznego przeprowadzania każdego kroku. Dzięki niemu będziesz mógł szybko i sprawnie przygotować system eSesja do efektywnego funkcjonowania w nowej kadencji, zachowując ciągłość działań i zapewniając spójność danych.</p>
            <p style="font-weight: bold; color: red;">Kreator należy przeprowadzić dopiero po odbyciu ostatniego posiedzenia w obecnej kadencji!</p>
            <p style="font-weight: bold;">Przed skorzystaniem z kreatora, prosimy o zapoznanie się z instrukcją: <span style="font-weight: bold; text-decoration: underline; cursor: pointer;" @click="goToInstruction()">KLIKNIJ TUTAJ</span></p>
        </section>
        <section class="new-cadence-introduction__action">
            <ButtonWithIcon :icon="'play'" :text="'Rozpocznij'" :classModified="true" @click="moveToStepOne" />
        </section>
    </section>
</template>
<script charset="utf-8">
    import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue"

    export default {
        name: "Step0Introduction",
        components: {
            ButtonWithIcon
        },
        methods: {
            async moveToStepOne() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 1 } });
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },
            goToInstruction() {
                window.open('https://pomoc.mwc.pl/kreator/', '_blank');
            }
        }
    }
</script>
<style lang="scss">
    .new-cadence-introduction {
        //width: 60vw;
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        text-align: center;

        &__title {
            display: flex;
            justify-content: center;

            h1 {
                font-size: 24px;
            }
        }

        &__description {
            line-height: 150%;
        }

        &__action {
            display: flex;
            justify-content: center;

            .btn-component--red {
                img {
                    filter: invert(1);
                }
            }
        }
    }
</style>